import React from "react";
import { View } from 'react-native';
export default function Video(props) {
    // const { ...rest } = props;
    return (
        <View>
        </View>
    )
}